import React from 'react';
import { Box, Button } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import Searchbox from '../elements/searchbox.element';

interface SearchProps {
  placeholder?: string;
  onFilter: (searchTerm: string) => void;
  showButton?: boolean;
  buttonLabel?: string;
}

const Search: React.FC<SearchProps> = ({
  onFilter,
  placeholder,
  buttonLabel,
  showButton = true,
}) => {
  const [searchTerm, setSearchTerm] = React.useState('');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: '100%',
      }}
    >
      <Searchbox
        placeholder={placeholder}
        onSearch={(term) => {
          setSearchTerm(term);
          if (!showButton) {
            onFilter(term);
          }
        }}
      />
      {showButton && (
        <Button
          variant="outlined"
          startIcon={<FilterListIcon />}
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            color: 'black',
            borderColor: '#ddd',
            backgroundColor: '#fff',
            '&:hover': {
              borderColor: '#bbb',
              backgroundColor: '#f5f5f5',
            },
          }}
          onClick={() => onFilter(searchTerm)}
        >
          {buttonLabel ?? 'Filter'}
        </Button>
      )}
    </Box>
  );
};

export default Search;
